import React from "react";
import { routes } from "../constants/routes";

const AboutSection = () => {
  return (
    <section className="bg-white py-20 md:py-32" id="about">
      <p className="text-blue-600 text-4xl md:flex-col-reversetext-5xl font-semibold text-center">
        What we're doing.
      </p>
      <p className="text-black text-4xl md:flex-col-reversetext-5xl font-semibold text-center">
        And <span className="">why.</span>
      </p>

      <div className="container-lg grid md:grid-cols-3 gap-7 mt-16 items-center">
        <a href={routes.learnscratch}>
          <div className="text-center mx-auto rounded-xl  hover:shadow-xl bg-gray-50 group hover:bg-white transition-all ease-out transform duration-700 delay-150 hover:-translate-y-2 p-8">
            <img
              className="h-20 mx-auto"
              src="https://www.flaticon.com/svg/static/icons/svg/2468/2468081.svg"
            />

            <div className="mt-8">
              <p className="font-semibold text-gray-700 transition-all duration-150 group-hover:text-black text-xl">
                Scratch Courses
              </p>
              <p className="font-medium text-gray-500  transition-all duration-150 group-hover:text-gray-600 text-sm mt-3">
                Taking students from complete beginners to full-fledged
                computing machines through an in-depth, heavily-tested course.
              </p>
            </div>
          </div>
        </a>

        <a href={routes.scratchathon}>
          <div className="text-center mx-auto rounded-xl hover:shadow-xl bg-blue-600 hover:bg-blue-500 transition-all ease-out transform duration-700 delay-150 hover:-translate-y-2 p-8">
            <img
              className="h-20 mx-auto white-icon"
              src="https://www.flaticon.com/svg/static/icons/svg/1720/1720448.svg"
            />

            <div className="mt-8">
              <p className="font-semibold text-white text-xl">
                Quarterly Scratchathons
              </p>
              <p className="font-medium text-gray-200 text-sm mt-3">
                Giving the Scratch community a chance to participate and a
                competitive and engaged community, pushing them to take their
                scratch skills to the next level.
              </p>
            </div>
          </div>
        </a>

        <a href={routes.contact}>
          <div className="text-center mx-auto rounded-xl  hover:shadow-xl bg-gray-50 group hover:bg-white transition-all ease-out transform duration-700 delay-150 hover:-translate-y-2 p-8">
            <img
              className="h-20 mx-auto"
              src="https://www.flaticon.com/svg/static/icons/svg/1469/1469884.svg"
            />

            <div className="mt-8">
              <p className="font-semibold text-gray-700 transition-all duration-150 group-hover:text-black text-xl">
                Personalized Events
              </p>
              <p className="font-medium text-gray-500  transition-all duration-150 group-hover:text-gray-600 text-sm mt-3">
                Working with individual institutions to center our services to
                your needs, engaging your youth community in the world of
                programming.
              </p>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default AboutSection;
